import React from "react";
import { FaFilePdf, FaExternalLinkAlt } from "react-icons/fa";
import styles from "../subscriptions.module.css";

const STATUS_LABELS = {
  paid:     "Pago",
  unpaid:   "Não pago",
  pending:  "Pendente",
  open:     "Pendente",
  failed:   "Falhou",
  refunded: "Reembolsado",
  voided:   "Anulada",
  draft:    "Rascunho"
};

const STATUS_CLASS = {
  paid:     styles.paid,
  unpaid:   styles.unpaid,
  pending:  styles.pending,
  open:     styles.pending,
  failed:   styles.failed,
  refunded: styles.refunded,
  voided:   styles.voided,
  draft:    styles.draft
};

const InvoiceList = ({ invoices, formatCurrency, formatDate }) => {
  if (!invoices || invoices.length === 0) {
    return (
      <div className={styles.tableWrap}>
        <div className={styles.emptyState}>
          <i className="fas fa-file-invoice" />
          Nenhuma fatura encontrada.
        </div>
      </div>
    );
  }

  return (
    <div className={styles.tableWrap}>
      <div style={{ overflowX: "auto" }}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Data</th>
              <th>Status</th>
              <th className={styles.right}>Valor</th>
              <th>Moeda</th>
              <th className={styles.center}>Pagamento</th>
              <th className={styles.center}>PDF</th>
            </tr>
          </thead>
          <tbody>
            {invoices.map(invoice => {
              const statusKey = invoice.status?.toLowerCase() || "";
              const isPaid = statusKey === "paid";
              return (
                <tr key={invoice.id || invoice.payment_id}>
                  <td className={styles.tdDate}>{formatDate(invoice.created_at)}</td>
                  <td>
                    <span className={`${styles.badge} ${STATUS_CLASS[statusKey] || ""}`}>
                      {STATUS_LABELS[statusKey] || invoice.status}
                    </span>
                  </td>
                  <td className={`${styles.tdAmount} ${styles.right}`}>
                    {formatCurrency(invoice.amount)}
                  </td>
                  <td className={styles.tdCurrency}>{invoice.currency?.toUpperCase()}</td>
                  <td className={styles.center}>
                    {invoice.hosted_invoice_url ? (
                      <a
                        href={invoice.hosted_invoice_url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={`${styles.iconBtn} ${styles.iconBtnLink} ${isPaid ? styles.iconBtnDisabled : ""}`}
                        title="Acessar página de pagamento"
                        onClick={isPaid ? e => e.preventDefault() : undefined}
                      >
                        <FaExternalLinkAlt size={11} />
                      </a>
                    ) : "—"}
                  </td>
                  <td className={styles.center}>
                    {invoice.invoice_pdf ? (
                      <a
                        href={invoice.invoice_pdf}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={`${styles.iconBtn} ${styles.iconBtnPdf}`}
                        title="Baixar fatura em PDF"
                      >
                        <FaFilePdf size={11} />
                      </a>
                    ) : "—"}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default InvoiceList;
